<form
  #form="ngForm"
  novalidate
>
  <h1 class="mb-4 justify-self-center text-xl">Tank Stock</h1>
  <re-in-use-tanks id="inUseTanks"></re-in-use-tanks>
  <re-not-in-use-tanks id="notInUseTanks"></re-not-in-use-tanks>
  <re-fuel-type-totals></re-fuel-type-totals>
</form>
